import utils from './utils'

const materials = (project) => {
  return [
    utils.unitField({
      prepend: 'meta.',
      customUnits: project.meta.units || [],
    }),
    utils.rateTable({
      inheritUnit: true,
    }), 
  ]
}

export default materials